(function () {
  function initFAQ(section) {
    var items = section.querySelectorAll('[data-faq-item]');

    // Accordion: one open at a time
    items.forEach(function (item) {
      var btn = item.querySelector('.faq__question');
      var answer = item.querySelector('.faq__answer');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        // Close all
        items.forEach(function (other) {
          var otherBtn = other.querySelector('.faq__question');
          var otherAnswer = other.querySelector('.faq__answer');
          if (otherBtn && otherAnswer) {
            otherBtn.setAttribute('aria-expanded', 'false');
            otherAnswer.classList.remove('is-open');
          }
        });

        // Open clicked if it was closed
        if (!isOpen) {
          btn.setAttribute('aria-expanded', 'true');
          answer.classList.add('is-open');
        }
      });
    });

    // Mobile select: jump to category
    var select = section.querySelector('.faq__mobile-select');
    if (select) {
      select.addEventListener('change', function () {
        var target = document.getElementById(select.value);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    // Sidebar: highlight active category on scroll
    var categories = section.querySelectorAll('.faq__category');
    var sidebarLinks = section.querySelectorAll('.faq__sidebar-link');

    if (categories.length && sidebarLinks.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              sidebarLinks.forEach(function (link) {
                link.classList.remove('is-active');
              });
              var activeLink = section.querySelector(
                '.faq__sidebar-link[href="#' + entry.target.id + '"]'
              );
              if (activeLink) activeLink.classList.add('is-active');
            }
          });
        },
        { rootMargin: '-10% 0px -80% 0px' }
      );

      categories.forEach(function (cat) {
        observer.observe(cat);
      });
    }
  }

  var faqSection = document.querySelector('.faq');
  if (faqSection) initFAQ(faqSection);

  // Re-init on theme editor section reload
  document.addEventListener('shopify:section:load', function (event) {
    var faq = event.target.querySelector('.faq');
    if (faq) initFAQ(faq);
  });
})();
